// @ts-nocheck
import * as Yup from "yup";

const contractorTypesObj = {
  NA: "NA",
  1099: "1099",
  w2: "w2",
  "V.C.": "V.C.",
  TBD: "TBD",
  // outSource: "outSource",
  // thirdParty: "thirdParty",
};

const contractorTypesFrontend = {
  NA: "NA",
  1099: "1099",
  w2: "W2",
  "V.C.": "V.C.",
  outSource: "Outsourced",
  thirdParty: "Third Party",
  TBD: "TBD",
};

const contractorTypes = Object.entries(contractorTypesObj).map((type) => {
  return type[1];
});

const addContractorStep1InitialValues = {
  firstName: "",
  lastName: "",
  mobile: "",
  email: "",
  mailingAddress: "",
  city: "",
  state: "",
  zipCode: "",
  // einNumber: "",
  companyName: "",
};

const addBulkContractorValues = {
  firstName: "",
  lastName: "",
  mobile: "",
  email: "",
  mailingAddress: "",
  city: "",
  state: "",
  zipCode: "",
  // einNumber: "",
  companyName: "",
  isActive: "",
  contractorType: "",
  isApproved: "",
};

const mobileSchema = Yup.string()
  .matches(/^\d{3}-\d{3}-\d{4}$/, "Phone number must be of 10 digit")
  .required("Phone Number is required!");

const formSchema = Yup.object().shape({
  firstName: Yup.string()
    .trim()
    .max(100, "First Name should be at most 100 characters!")
    .required("First Name is required!"),
  lastName: Yup.string()
    .trim()
    .max(100, "Last Name should be at most 100 characters!")
    .required("Last Name is required!"),
  email: Yup.string().trim().email().required("Email is required!"),
  mailingAddress: Yup.string()
    .trim()
    .max(255, "Mailing address should be at most 255 characters!")
    .required("Mailing Address is required!"),
  city: Yup.string()
    .trim()
    .max(80, "City should be at most 80 characters!")
    .required("City is required!")
    .test("select-valid-city", "Please select a valid city", function () {
      const city = this.parent.city;
      const state = this.parent.state;

      return !(
        state !== "Select state" &&
        (city === "Select city" || city === "Please select state first")
      );
    }),
  state: Yup.string()
    .trim()
    .max(80, "State should be at most 80 characters!")
    .required("State is required!")
    .test("select-valid-state", "Please select a valid state", function () {
      const state = this.parent.state;

      return state !== "Select state";
    }),
  zipCode: Yup.string()
    .max(15, "Zip code should be at most 15 characters!")
    .required("Zipcode is required!"),
  // einNumber: Yup.string()
  //   .typeError("EIN Number should be a number!")
  //   .required("EIN Number is required!"),
  companyName: Yup.string().max(
    255,
    "Company Name should be at most 255 characters!",
  ),
});

const addBulkContractorSchema = Yup.object().shape({
  firstName: Yup.string()
    .max(100, "First Name should be at most 100 characters!")
    .required("First Name is required!"),
  lastName: Yup.string().max(
    100,
    "Last Name should be at most 100 characters!",
  ),
  email: Yup.string().required("Email is required!"),
  mailingAddress: Yup.string().max(
    255,
    "mailing addres should be at most 255 characters!",
  ),
  city: Yup.string()
    .max(80, "City should be at most 80 characters!")
    .test("select-valid-city", "Please select a valid city", function () {
      const city = this.parent.city;
      const state = this.parent.state;

      return !(
        state !== "Select state" &&
        (city === "Select city" || city === "Please select state first")
      );
    }),
  state: Yup.string()
    .max(80, "State should be at most 80 characters!")
    .test("select-valid-state", "Please select a valid state", function () {
      const state = this.parent.state;

      return state !== "Select state";
    }),
  zipCode: Yup.string().max(15, "Zip code should be at most 15 characters"),
  // einNumber: Yup.string()
  //   .typeError("EIN Number should be a number!"),
  contractorType: Yup.string()
    .oneOf(
      contractorTypes,
      `Contractor Type must be of the types: ${contractorTypes
        ?.map((type) => (type === "NA" ? "N/A" : type))
        ?.join(", ")}`,
    )
    .required("Contractor Type is required!"),
  companyName: Yup.string()
    .max(255, "Company Name should be at most 255 characters!")
    .when("contractorType", {
      is: contractorTypesObj["V.C."],
      then: () =>
        Yup.string().required(
          `Company name is required when contractor type is ${contractorTypesObj["V.C."]}!`,
        ),
    }),
  roleExperience: Yup.array().of(
    Yup.object().shape({
      role: Yup.string().trim().max(30).required("Position Name is required!"),
      experience: Yup.number().required("Experience is required!"),
    }),
  ),
});

const formSchemaWithMobile = formSchema.concat(
  Yup.object().shape(mobileSchema),
);

export default formSchema;
export {
  formSchemaWithMobile,
  addContractorStep1InitialValues,
  addBulkContractorValues,
  addBulkContractorSchema,
  contractorTypesObj,
  contractorTypes,
  contractorTypesFrontend,
};